import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsNutritionData = (props: Props) => {
  const { entries } = props;

  return (
    <BodyText sizeMatch={['18']} style={styles.text}>
      {formatNutritionData(entries)}
    </BodyText>
  );
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function formatNutritionData(entries: NutritionDataEntry[]) {
  return entries.map((item) => `${item.value} ${item.labelShort ?? item.label}`).join('  |  ');
}

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    color: theme.colors.OPACITY.DARK_KALE.DARKER,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  entries: NutritionDataEntry[];
};

type NutritionDataEntry = {
  label: string;
  labelShort?: string;
  value: string | number;
};
